import { render, staticRenderFns } from "./system_configuration.vue?vue&type=template&id=7ecff640&scoped=true&"
import script from "./system_configuration.vue?vue&type=script&lang=js&"
export * from "./system_configuration.vue?vue&type=script&lang=js&"
import style0 from "./system_configuration.vue?vue&type=style&index=0&id=7ecff640&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecff640",
  null
  
)

export default component.exports